import { styled } from 'styled-components';

import { spacing2 } from 'src/styles/spacing';

export const StyledContainer = styled.div`
  width: 100%;
  max-width: ${({ theme }) => theme.container.maxWidth};
  box-sizing: border-box;
  padding: 0 ${spacing2};
  margin: 0 auto;
`;
